import React from 'react';
import LoginLeft from '../../Component/Login/loginLeft'
import LoginRight from '../../Component/Login/loginRight';
import styles from './loginPage.module.css';

function LoginPage() {
    return (
        <div className = {styles.main}> 
            <LoginLeft />
            <LoginRight />
        </div>
    )
}

export default LoginPage;
